import React, { useEffect, useState } from 'react';
import { connect } from "react-redux";
import { Typography, Divider, LinkList, LinkListItem, Button, Drawer } from "../ecosystem";
import { getFirstName, titleCase, isRxRoute } from "../../helpers/formatting";
import DrawerProxySelector from '../common/Proxy/DrawerProxySelector';
import DrawerProxySection from '../common/Proxy/DrawerProxySection';
import DrawerProxyItem from '../common/Proxy/DrawerProxyItem';

const HeaderProxySelectorMobile = (props) => {
    const { isOpen, history, bundle, userList, primaryUser, pharmacyUsers, setMobileMenuOpen, isAdult,
        orderRefillCompleted, rxTransferCompleted, onChange, activeUser, isShowAllUsers } = props;

    const urlPath = history && history.location ? history.location.pathname : '/';
    const isDashboardPage = urlPath === "/";
    const isPharmacyPage = (bundle === "pharmacy" || urlPath === '/pharmacy' || isRxRoute(urlPath));
    const isProxySelection = urlPath.toLowerCase().indexOf("/familyselection") !== -1;

    const requestCompleted = (orderRefillCompleted && /rxrefill/.test(urlPath.toLowerCase())) || (rxTransferCompleted && /bswtransfer/.test(urlPath.toLowerCase()));
    const pathname = (urlPath && isRxRoute(urlPath) && !requestCompleted) || blockUserSwitch ? urlPath : '/pharmacy';

    const blockUserSwitch=()=> {
        return history && history.location && history.location.pathname && history.location.pathname.toLowerCase().indexOf("/findcare/vaccine") !== -1;
    }

    return <>
        <DrawerProxySelector
            name={primaryUser && primaryUser.displayName}
            open={isOpen}
            isAdult={isAdult}
            toggle={() => setMobileMenuOpen(false)}
            onAddFamilyClick={(e) => {
                onChange({ value: "GrantAccess" });
                setMobileMenuOpen(false);
            }}
        >
            {primaryUser &&
                <DrawerProxySection
                    heading="Your Account"
                >
                    <DrawerProxyItem
                        name={getFirstName(primaryUser.displayName) }
                        showViewing={!isShowAllUsers && activeUser && activeUser.externalId && primaryUser.externalId && primaryUser.externalId === activeUser.externalId}
                        linkProps={{
                            to: { urlPath }
                        }}
                        onClick={() => {
                            setMobileMenuOpen(false);
                            onChange({ label: getFirstName(primaryUser.displayName), user: primaryUser });
                        }}
                    />
                    {userList && userList.length > 0 && 
                        <DrawerProxySection
                            heading="Family Medical Records"
                        >
                            <DrawerProxyItem
                                name={"View All"}
                                disabled={!(isDashboardPage || isProxySelection)}
                                showViewing={(isShowAllUsers && !isPharmacyPage) && (isDashboardPage || isProxySelection) }
                                onClick={() => {
                                    setMobileMenuOpen(false);
                                    onChange({ label: "View All", user: primaryUser });
                                }}
                            />
                            <Divider mTop="xsmall" mBottom="xsmall" mHorizontal="none" />

                            {userList && userList.map((user, index) => {
                                return (<React.Fragment key={index}>
                                    <DrawerProxyItem
                                        name={getFirstName(user.displayName)}
                                        showViewing={!isShowAllUsers && !isPharmacyPage && activeUser && activeUser.externalId && user.externalId && user.externalId === activeUser.externalId}
                                        linkProps={{
                                            to: { urlPath }
                                        }}
                                        onClick={() => {
                                            setMobileMenuOpen(false);
                                            onChange({ label: getFirstName(user.displayName), user: user });
                                        }}
                                    />
                                    {index !== (userList.length - 1) && <Divider mTop="xsmall" mBottom="xsmall" mHorizontal="none" />}
                                </React.Fragment>)
                            }
                            )}
                        </DrawerProxySection>
                    }
                    {pharmacyUsers && pharmacyUsers.length > 0 &&
                        <DrawerProxySection
                            heading="Family BSW Pharmacy account"
                        >
                            {pharmacyUsers && pharmacyUsers.map((user, index) => {
                                return (<React.Fragment key={index}>
                                    <DrawerProxyItem
                                        name={titleCase(user.firstName)}
                                        showViewing={!isShowAllUsers && isPharmacyPage && activeUser && activeUser.pharmacyPatientId && user.pharmacyPatientId && user.pharmacyPatientId === activeUser.pharmacyPatientId}
                                        linkProps={{
                                            to: { pathname }
                                        }}
                                        onClick={() => {
                                            setMobileMenuOpen(false);
                                            onChange({ label: titleCase(user.displayName), user: user });
                                        }}
                                    />
                                    {index !== (pharmacyUsers.length - 1) && <Divider mTop="xsmall" mBottom="xsmall" mHorizontal="none" />}
                                </React.Fragment>)
                            }
                            )}
                        </DrawerProxySection>
                    }
                </DrawerProxySection>
            }
        </DrawerProxySelector>
    </>

}

const mapStateToProps = (state) => {
    const { submitOrderResult, transfer } = state.pharmacy;
    return {
        history: state.session.history,
        bundle: state.session.serverData.bundle.toLowerCase(),
        orderRefillCompleted: submitOrderResult && (submitOrderResult.SuccessRx || submitOrderResult.RenewedRx || submitOrderResult.FailuresRx),
        rxTransferCompleted: transfer && (transfer.error || transfer.result),
    }
}

export default connect(mapStateToProps)(HeaderProxySelectorMobile);
